import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import api from '../../services/api'
import {
  GET_COMPANY_PROFILE,
  UPDATE_COMPANY_PROFILE
} from '../../helpers/url_helper'

// Async thunk for fetching company profile
export const fetchCompanyProfile = createAsyncThunk(
  'company/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_COMPANY_PROFILE)
      return response.data.company
    } catch (error) {
      const message = error.response?.data?.error || 'Failed to fetch company profile'
      if (error.response?.status !== 401) toast.error(message)
      return rejectWithValue(message)
    }
  }
)

// Async thunk for updating company profile
export const updateCompanyProfile = createAsyncThunk(
  'company/updateProfile',
  async (companyData, { rejectWithValue }) => {
    try {
      const response = await api.put(UPDATE_COMPANY_PROFILE, companyData)
      toast.success('Company profile updated successfully')
      return response.data.company
    } catch (error) {
      const message = error.response?.data?.error || 
                     error.response?.data?.message || 
                     'Failed to update company profile'
      toast.error(message)
      return rejectWithValue(message)
    }
  }
)

const initialState = {
  companyProfile: null,
  loading: false,
  error: null,
}

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    clearError: state => {
      state.error = null
    },
  },
  extraReducers: builder => {
    builder
      // Fetch Company Profile
      .addCase(fetchCompanyProfile.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCompanyProfile.fulfilled, (state, action) => {
        state.loading = false
        state.companyProfile = action.payload
      })
      .addCase(fetchCompanyProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      // Update Company Profile
      .addCase(updateCompanyProfile.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(updateCompanyProfile.fulfilled, (state, action) => {
        state.loading = false
        state.companyProfile = action.payload
      })
      .addCase(updateCompanyProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { clearError } = companySlice.actions
export default companySlice.reducer
